module.exports = __webpack_public_path__ + "img/person_placeholder.761c70dd.svg";